import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employee',
  'Employment Type',
  'Gender',
  'Location',
  'Manager',
  'Pay Rate',
  'Start Date'
];

const ActiveEmployeesReport = () => {
  return (
    <CompositeReport filters={filters}>
      <Report name={t('reports.ACTIVE_EMPLOYEES_REPORT')}
              url='/reports/active_employees'>
      </Report>
    </CompositeReport>
  );
};

export default ActiveEmployeesReport;
